import React from 'react'
import styled from 'styled-components'
import FICBaseButton from './FICBaseButton'
import PropTypes from 'prop-types'
import FICColors from '../../../common/styles/FICColors'

/**
 * Renderizza un tag <a>
 * accetta solo testo (obbligatorio) e due parametri opzionali per il colore (color, colorHover)
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function FICLinkImpl (props) {
  return <FICBaseButton {...props}
    className={props.className}
    style={props.style}
    renderButton={renderLink}
  />
}

function renderLink (props) {
  return props.text
}

const FICLink = styled(FICLinkImpl)`
  color: ${props => props.color ? props.color : FICColors.link.normal};
  cursor: pointer;
  text-decoration: none;
  &:hover{
    color: ${props => props.colorHover ? props.colorHover : FICColors.link.hover};
    text-decoration: underline;
  }
`

FICLink.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  renderButton: PropTypes.func,
  color: PropTypes.string,
  colorHover: PropTypes.string,
  style: PropTypes.object,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

FICLink.defaultProps = {
  ...FICBaseButton.defaultProps,
  color: undefined,
  colorHover: undefined,
  text: '',
  className: undefined
}

FICLinkImpl.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

FICLinkImpl.defaultProps = {
  className: undefined,
  style: undefined
}

export default FICLink



// WEBPACK FOOTER //
// ./src/common/components-v2/FICButton/FICLink.js